import { ErrorOption, LiteralUnion, RegisterOptions } from 'react-hook-form';

export const createFormErrorMessage = (
  type: LiteralUnion<keyof RegisterOptions, string>,
  message: string
): ErrorOption => {
  return { type, message };
};
